import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/src/components/(pages)/home/Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/app/src/components/(pages)/home/NavigationBar.jsx");
